module.exports = __webpack_public_path__ + "img/job-card-date.0d5e38b6.svg";